// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/
// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.
// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx
import baseIcon from '@bubble-ui/temp-icon-base';
var ActionIconClosePath = 'M11.147,9.994 C11.439,9.861 11.716,9.683 11.956,9.443 L15.714,5.684 L14.3,4.27 L10.542,8.029 C10.241,8.329 9.751,8.33 9.451,8.029 L5.714,4.293 L4.3,5.707 L8.037,9.443 C8.283,9.689 8.566,9.872 8.867,10.006 C8.575,10.139 8.298,10.316 8.058,10.556 L4.3,14.315 L5.714,15.729 L9.472,11.972 C9.774,11.668 10.264,11.671 10.564,11.971 L14.3,15.707 L15.714,14.293 L11.978,10.556 C11.732,10.31 11.448,10.128 11.147,9.994';
var ActionIconClose = baseIcon('ActionIconClose', {
  getPath: function getPath() {
    return ActionIconClosePath;
  }
});
export default ActionIconClose;
//# sourceMappingURL=index.js.map